import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Reveal } from './ui/Reveal';
import { BackgroundGradient } from './ui/background-gradient';

export const Contact: React.FC = () => {
    const [status, setStatus] = useState<'idle' | 'success'>('idle');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        
        const myForm = e.currentTarget;
        const formData = new FormData(myForm);
        
        try {
            await fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams(formData as any).toString(),
            });
            setStatus('success');
        } catch (error) {
            console.error("Form submission error:", error);
        }
    };

  return (
    <section id="contact" className="py-24 relative overflow-hidden bg-black">
      {/* Background radial gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-white/[0.03] rounded-full blur-[100px] -z-10" />

      <div className="max-w-3xl mx-auto px-6 text-center">
            <Reveal width="100%">
                <h2 className="text-3xl md:text-5xl font-bold mb-4 font-['Space_Grotesk']">
                    VUOI COSTRUIRE UNA COMMUNITY <br />
                    DI <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500">+10.000 FOLLOWER</span> PER <br />
                    LA TUA AZIENDA?
                </h2>
                <p className="text-gray-400 mb-12">Compila il modulo qui sotto e un esperto del nostro team ti contatterà!</p>
            </Reveal>

            {status === 'success' ? (
                <BackgroundGradient containerClassName="rounded-3xl" className="bg-zinc-950 p-12 rounded-3xl">
                    <div className="inline-block p-4 rounded-full bg-white text-black mb-4">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                    </div>
                    <h3 className="text-2xl font-bold mb-2 text-white">Richiesta Inviata!</h3>
                    <p className="text-gray-400">Ti contatteremo a breve.</p>
                </BackgroundGradient>
            ) : (
                <BackgroundGradient containerClassName="rounded-3xl" className="bg-zinc-950 p-8 md:p-12 rounded-3xl text-left">
                    <form 
                        name="contact" 
                        method="POST" 
                        data-netlify="true"
                        onSubmit={handleSubmit} 
                        className="space-y-6"
                    >
                        {/* Hidden input required for Netlify Forms in React */}
                        <input type="hidden" name="form-name" value="contact" />

                        <div className="space-y-2">
                            <input 
                                required
                                type="text" 
                                name="name"
                                placeholder="Nome" 
                                className="w-full bg-white/5 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-white/50 focus:bg-white/10 transition-all placeholder-gray-500"
                            />
                        </div>
                        <div className="space-y-2">
                            <input 
                                required
                                type="email" 
                                name="email"
                                placeholder="Email" 
                                className="w-full bg-white/5 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-white/50 focus:bg-white/10 transition-all placeholder-gray-500"
                            />
                        </div>
                         <div className="space-y-2">
                            <input 
                                required
                                type="tel" 
                                name="phone"
                                placeholder="Numero di Telefono" 
                                className="w-full bg-white/5 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-white/50 focus:bg-white/10 transition-all placeholder-gray-500"
                            />
                        </div>
                         <div className="space-y-2">
                            <textarea 
                                name="message"
                                placeholder="Parlaci della tua azienda" 
                                rows={4}
                                className="w-full bg-white/5 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-white/50 focus:bg-white/10 transition-all placeholder-gray-500 resize-none"
                            />
                        </div>

                        <div className="pt-4">
                            <Button type="submit" className="w-full bg-white text-black hover:bg-gray-200 py-5 text-lg shadow-[0_0_20px_rgba(255,255,255,0.2)]">
                                Invia Richiesta
                            </Button>
                        </div>
                    </form>
                </BackgroundGradient>
            )}
      </div>
    </section>
  );
};